// export const GETTERS_COHORTS = "GETTERS_COHORTS";
// export const ACTIONS_GET_COHORTS = "ACTIONS_GET_COHORTS";
// export const MUTATIONS_SET_COHORTS = "MUTATIONS_SET_COHORTS";
export const ACTIONS_UPDATE_MILESTONES = "ACTIONS_UPDATE_MILESTONES";



// WEBPACK FOOTER //
// ./src/store/modules/basic_program_milestones/constants.js